export const auth = {
  // Login
  login: 'Login',
  loginTitle: 'Welcome Back',
  loginSubtitle: 'Sign in to your account',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot Password?',
  noAccount: 'Don\'t have an account?',
  signUp: 'Sign Up',
  loginButton: 'Sign In',
  loggingIn: 'Signing in...',
  
  // Register
  register: 'Register',
  registerTitle: 'Create Account',
  registerSubtitle: 'Join MakanTak today',
  fullName: 'Full Name',
  confirmPassword: 'Confirm Password',
  haveAccount: 'Already have an account?',
  signIn: 'Sign In',
  registerButton: 'Create Account',
  registering: 'Creating account...',
  agreeToTerms: 'By signing up, you agree to our',
  termsOfService: 'Terms of Service',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  
  // Forgot Password
  forgotPasswordTitle: 'Reset Password',
  forgotPasswordSubtitle: 'Enter your email to receive reset instructions',
  sendResetLink: 'Send Reset Link',
  sending: 'Sending...',
  backToLogin: 'Back to Login',
  resetEmailSent: 'Reset email sent! Check your inbox.',
  
  // Reset Password
  resetPasswordTitle: 'Set New Password',
  resetPasswordSubtitle: 'Enter your new password',
  newPassword: 'New Password',
  resetPasswordButton: 'Reset Password',
  resetting: 'Resetting...',
  passwordResetSuccess: 'Password reset successfully!',
  
  // Validation
  emailRequired: 'Email is required',
  passwordRequired: 'Password is required',
  nameRequired: 'Full name is required',
  passwordsNotMatch: 'Passwords do not match',
  invalidEmail: 'Invalid email address',
  passwordTooShort: 'Password must be at least 6 characters',
};
